import "./style.css";
import DatePicker from 'react-datepicker';
import { de } from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';

const DataViewerTwoColoms = ({ data, onDataChange, onDateChange }) => {
	const dateFields = ['Beginn (Plan)', 'Ende (Plan)', 'Beginn (Ist)', 'Ende (Ist)'];

	const renderData = data ? data.map((info, index) => {
		if (dateFields.includes(info.infoKey)) {
			return (
				<div key={info.infoKey} className="data__options">
					<div>
						<p className="data__infoKey">{info.infoKey}</p>
					</div>
					<DatePicker
						selected={info.infoValue}
						onChange={(date) => onDateChange(date, index)}
						showTimeSelect
						dateFormat="Pp"
						className="data__infoValue editable-input"
						locale={de}
					/>
				</div>
			)
		}
		
		return (
			<div key={info.infoKey} className="data__options">
				<div>
					<p className="data__infoKey">{info.infoKey}</p>
				</div>
				<input
					type="text"
					value={info.infoValue}
					onChange={(e) => onDataChange(e, index)}
					className="data__infoValue editable-input"
				/>
			</div>
		)
	}) : null;

	return renderData;
}

export default DataViewerTwoColoms
